export default "__VITE_ASSET__73309468__"